import { createFileRoute } from "@tanstack/react-router";
import { OG_IMAGE, absolute, hreflangLinks } from "@/lib/site";
import { graph, breadcrumbList, faqPage } from "@/lib/schema";
import { content } from "@/lib/content";
import { ServicesContent } from "@/components/ServicesContent";

export const Route = createFileRoute("/ar/services/")({
  head: () => ({
    meta: [
      { title: "التحضير للأيزو وتسجيل الموردين في العراق | عراق سيرت" },
      {
        name: "description",
        content:
          "تعرّف على دعم التحضير لأنظمة إدارة الأيزو وتسجيل الموردين بحسب الجهة المشترية في العراق. حدد النطاق والخدمة المناسبة لمتطلب شركتك.",
      },
      { property: "og:title", content: "التحضير للأيزو وتسجيل الموردين في العراق | عراق سيرت" },
      {
        property: "og:description",
        content:
          "تعرّف على دعم التحضير لأنظمة إدارة الأيزو وتسجيل الموردين بحسب الجهة المشترية في العراق. حدد النطاق والخدمة المناسبة لمتطلب شركتك.",
      },
      { property: "og:url", content: absolute("/ar/services") },
      { property: "og:image", content: OG_IMAGE },
      { property: "og:locale", content: "ar_IQ" },
      { name: "twitter:image", content: OG_IMAGE },
    ],
    links: [{ rel: "canonical", href: absolute("/ar/services") }, ...hreflangLinks("/services")],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify(
          graph(
            breadcrumbList([
              { name: "الرئيسية", path: "/ar" },
              { name: "خدماتنا", path: "/ar/services" },
            ]),
            faqPage(
              "/ar/services",
              content.faq.servicesHub.map((f) => ({ q: f.q.ar, a: f.a.ar })),
            ),
          ),
        ),
      },
    ],
  }),
  component: ServicesContent,
});
